import IconBilling from '@remote-com/norma/icons/billing-deep.svg';
import IconBookOpen from '@remote-com/norma/icons/book-open-deep.svg';
import IconBriefcase from '@remote-com/norma/icons/briefcase-deep.svg';
import IconClosePanel from '@remote-com/norma/icons/close-panel.svg';
import IconDollarSign from '@remote-com/norma/icons/dollar-sign.svg';
import IconEdit from '@remote-com/norma/icons/edit-deep.svg';
import IconFileText from '@remote-com/norma/icons/file-text-deep.svg';
import IconFolder from '@remote-com/norma/icons/folder-plus.svg';
import IconGlobe from '@remote-com/norma/icons/globe-deep.svg';
import IconHeart from '@remote-com/norma/icons/heart.svg';
import IconHome from '@remote-com/norma/icons/home-deep.svg';
import IconJobsSearch from '@remote-com/norma/icons/jobs-search.svg';
import IconLock from '@remote-com/norma/icons/lock-deep.svg';
import IconMail from '@remote-com/norma/icons/mail.svg';
import IconPartners from '@remote-com/norma/icons/partners-deep.svg';
import IconPayslips from '@remote-com/norma/icons/payslips-deep.svg';
import IconPieChart from '@remote-com/norma/icons/pie-chart.svg';
import IconRocket from '@remote-com/norma/icons/rocket-deep.svg';
import IconSettings from '@remote-com/norma/icons/settings.svg';
import IconShieldCheck from '@remote-com/norma/icons/shield-check.svg';
import IconStar from '@remote-com/norma/icons/star.svg';
import IconSupport from '@remote-com/norma/icons/support.svg';
import IconUserCheck from '@remote-com/norma/icons/user-check.svg';
import IconUser from '@remote-com/norma/icons/user-deep.svg';
import IconUserPlus from '@remote-com/norma/icons/user-plus.svg';
import IconUsers from '@remote-com/norma/icons/users-deep.svg';
import styled from 'styled-components';

import UserChat from './assets/coaching.svg';
import CommunityIcon from './assets/community.svg';
import IconCalculator from './assets/cost-calculator.svg';
import IconFirm from './assets/firm.svg';
import IconTree from './assets/tree.svg';
import { SubMenuIcon } from './styles/Menu';

const SubMenuIconLeftWeight = styled(SubMenuIcon)`
  transform: translateX(3px);
`;

const UserChatIcon = styled(SubMenuIcon)`
  svg {
    fill: transparent;
  }
`;

export function SubMenuIconComponent({ name }) {
  switch (name) {
    case 'billing':
      return (
        <SubMenuIcon>
          <IconBilling />
        </SubMenuIcon>
      );
    case 'book-open':
      return (
        <SubMenuIcon>
          <IconBookOpen />
        </SubMenuIcon>
      );
    case 'briefcase':
      return (
        <SubMenuIcon>
          <IconBriefcase />
        </SubMenuIcon>
      );
    case 'calculator':
      return (
        <SubMenuIcon>
          <IconCalculator />
        </SubMenuIcon>
      );
    case 'close-panel':
      return (
        <SubMenuIcon>
          <IconClosePanel />
        </SubMenuIcon>
      );
    case 'coaching':
      return (
        <UserChatIcon>
          <UserChat />
        </UserChatIcon>
      );
    case 'community':
      return (
        <SubMenuIcon>
          <CommunityIcon />
        </SubMenuIcon>
      );
    case 'dollar-sign':
      return (
        <SubMenuIcon>
          <IconDollarSign />
        </SubMenuIcon>
      );
    case 'edit':
      return (
        <SubMenuIcon>
          <IconEdit />
        </SubMenuIcon>
      );
    case 'file-text':
      return (
        <SubMenuIcon>
          <IconFileText />
        </SubMenuIcon>
      );
    case 'firm':
      return (
        <SubMenuIcon>
          <IconFirm />
        </SubMenuIcon>
      );
    case 'folder-plus':
      return (
        <SubMenuIcon>
          <IconFolder />
        </SubMenuIcon>
      );
    case 'globe':
      return (
        <SubMenuIcon>
          <IconGlobe />
        </SubMenuIcon>
      );
    case 'heart':
      return (
        <SubMenuIcon>
          <IconHeart />
        </SubMenuIcon>
      );
    case 'home':
      return (
        <SubMenuIcon>
          <IconHome />
        </SubMenuIcon>
      );
    case 'jobs-search':
      return (
        <SubMenuIcon>
          <IconJobsSearch />
        </SubMenuIcon>
      );
    case 'lock':
      return (
        <SubMenuIcon>
          <IconLock />
        </SubMenuIcon>
      );
    case 'mail':
      return (
        <SubMenuIcon>
          <IconMail />
        </SubMenuIcon>
      );
    case 'partners':
      return (
        <SubMenuIcon>
          <IconPartners />
        </SubMenuIcon>
      );
    case 'payslips':
      return (
        <SubMenuIcon>
          <IconPayslips />
        </SubMenuIcon>
      );
    case 'pie-chart':
      return (
        <SubMenuIcon>
          <IconPieChart />
        </SubMenuIcon>
      );
    case 'rocket':
      return (
        <SubMenuIcon>
          <IconRocket />
        </SubMenuIcon>
      );
    case 'settings':
      return (
        <SubMenuIcon>
          <IconSettings />
        </SubMenuIcon>
      );
    case 'shield-check':
      return (
        <SubMenuIcon>
          <IconShieldCheck />
        </SubMenuIcon>
      );
    case 'star':
      return (
        <SubMenuIcon>
          <IconStar />
        </SubMenuIcon>
      );
    case 'support':
      return (
        <SubMenuIcon>
          <IconSupport />
        </SubMenuIcon>
      );
    case 'tree':
      return (
        <SubMenuIcon>
          <IconTree />
        </SubMenuIcon>
      );
    case 'user-check':
      return (
        <SubMenuIconLeftWeight>
          <IconUserCheck />
        </SubMenuIconLeftWeight>
      );
    case 'user':
      return (
        <SubMenuIcon>
          <IconUser />
        </SubMenuIcon>
      );
    case 'user-plus':
      return (
        <SubMenuIcon>
          <IconUserPlus />
        </SubMenuIcon>
      );
    case 'users':
      return (
        <SubMenuIcon>
          <IconUsers />
        </SubMenuIcon>
      );
    default:
      return null;
  }
}
